module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/header/header.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/header/header.component.css
// module chunks = main